import { connect } from "react-redux";

import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { withResolvePaths } from "../../withResolvePaths";
import { withFocusManagement } from "../../Services/FocusManagement/withFocusManagement";
import { CandyDispatch } from "../../../Engine/Core/Store/CandyReduxTypes";
import { isNotNullOrUndefined } from "../../../../../Common/TypingUtils";
import {
    FormActionHandlerExecutionInjectableProps,
    withFormActionHandlerExecution,
} from "../../Internals/FormActionHandlers/WithFormActionHandlerExecution";
import { FormActionHandler } from "../../Internals/FormActionHandlers/FormActionHandler";
import { AbsoluteResolvedModelPath } from "../../../../../Common/ModelPath/ModelPath";
import { EvaluableProp, withEvaluators } from "../../withEvaluators";
import { withViewModelSelect } from "../../withViewModelSelect";

import { TabTitle } from "./TabTitle";

interface TabTitleProps extends FormActionHandlerExecutionInjectableProps {
    onClose?: FormActionHandler;
    children: React.ReactNode;
    bindingPath?: AbsoluteResolvedModelPath;
    disabled?: boolean;
    disableClose?: EvaluableProp<boolean>;
    processEvaluableProp: <T>(state: FullFormState, prop: EvaluableProp<T>) => T;
}

const mapDispatchToProps = (_: CandyDispatch, ownProps: TabTitleProps) => ({
    onClose: ownProps.onClose
        ? async () => {
              if (isNotNullOrUndefined(ownProps.onClose)) {
                  await ownProps.executeFormActionHandler(ownProps.onClose);
              }
          }
        : ownProps.onClose,
});

const mapStateToProps = (state: FullFormState, ownProps: TabTitleProps) => {
    const { disableClose, processEvaluableProp } = ownProps;
    return {
        isReadOnly: state.settings.isReadOnly,
        disabled: disableClose === undefined ? true : processEvaluableProp(state, disableClose),
    };
};

export const TabTitleContainer = withResolvePaths(
    withFormActionHandlerExecution(
        withViewModelSelect(withFocusManagement(withEvaluators(connect(mapStateToProps, mapDispatchToProps)(TabTitle))))
    )
);
